import React from 'react';
import { cn } from '@/lib/utils';

type PillVariant = 'success' | 'warning' | 'error' | 'info' | 'muted';

interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: PillVariant;
}

const variantClasses: Record<PillVariant, string> = {
  success: 'bg-emerald-100 text-emerald-800',
  warning: 'bg-amber-100 text-amber-800',
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
  muted: 'bg-gray-100 text-gray-700',
};

const Pill: React.FC<PillProps> = ({ variant = 'muted', className, children, ...props }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-semibold',
      variantClasses[variant],
      className
    )}
    {...props}
  >
    {children}
  </span>
);

export { Pill };
export type { PillProps, PillVariant };
